module.exports = __webpack_public_path__ + "img/wallpaper-1.db8449fc.jpg";